import { render, staticRenderFns } from "./NoticeForm.vue?vue&type=template&id=66e634b6&scoped=true&"
import script from "./NoticeForm.vue?vue&type=script&lang=js&"
export * from "./NoticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e634b6",
  null
  
)

export default component.exports